import React, { Component, Fragment } from "react";
import { Trans, withTranslation } from "react-i18next";
import i18n from "../../../../i18n";
import {
  withAuthentication,
  Form,
  FormHeader,
  Button,
  ResultsCounter,
  Actions,
  ButtonSecondary,
  Table,
  CheckboxElement,
  Link,
  withQualificationsApi,
  // AutocompleteTextfieldApiElement,
} from "cw-styleguide-react";
import withAssets from "../../../../components/hoc/withAssets";
import { STEP_QUALIFICATION_CREATE, ROLE_STAFF } from "../../../../constants";
import ErrorNavigation from "../../../../components/ErrorNavigation";
import AutocompleteTextfieldApiElement from '../AutocompleteTextfieldApiElement';

class QualificationsViewStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedQualifications: new Set(),
    };

    this.handleAddQualification = this.handleAddQualification.bind(this);
    this.handleSelectQualification = this.handleSelectQualification.bind(this);
    this.handleRemoveQualifications =
      this.handleRemoveQualifications.bind(this);
    this.handleToggleUnkownQualifications =
      this.handleToggleUnkownQualifications.bind(this);
  }

  handleAddQualification(e) {
    e.preventDefault();

    let qualifications = this.props.qualifications;

    if (
      !qualifications.some(
        (qualification) => qualification.id === this.props.qualificationId
      )
    ) {
      this.props.qualificationsApiGetQualifications(
        this.props.qualificationId,
        i18n.language,
        (response) => {
          const qualification = response.data[0];
          qualifications.push(qualification);
          // this.props.handleSet('qualifications', qualifications);

          this.props.handleSet({
            qualifications: qualifications,
            qualificationId: "",
            qualificationLabel: "",
          });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  handleSelectQualification(e) {
    const selectedQualifications = this.state.selectedQualifications;
    const selectedQualificationId = e.target.value;

    if (selectedQualifications.has(selectedQualificationId)) {
      selectedQualifications.delete(selectedQualificationId);
    } else {
      selectedQualifications.add(selectedQualificationId);
    }

    this.setState(selectedQualifications);
  }

  handleRemoveQualifications(e) {
    e.preventDefault();

    const selectedQualifications = this.state.selectedQualifications;

    let qualifications = this.props.qualifications;
    let manualQualifications = this.props.manualQualifications;

    qualifications = qualifications.filter(
      (qualification) =>
        !selectedQualifications.has(qualification.qwApprovalDesignationNo)
    );
    manualQualifications = manualQualifications.filter(
      (manualQualification) =>
        !selectedQualifications.has(manualQualification.uuid)
    );

    this.props.handleSet({
      qualifications: qualifications,
      manualQualifications: manualQualifications,
    });

    selectedQualifications.clear();

    this.setState(selectedQualifications);
  }

  handleToggleUnkownQualifications(e) {
    this.props.handleChange(e);

    if (e.target.value === "1") {
      this.props.handleSet({
        qualifications: [],
        manualQualifications: [],
      });
    }
  }

  render() {
    const filters = this.props.courses.assets.qualifications;
    const qualifications = this.props.qualifications.map((qualification) => {
      return [
        <CheckboxElement
          checked={this.state.selectedQualifications.has(
            qualification.qwApprovalDesignationNo
          )}
          value={qualification.qwApprovalDesignationNo}
          onChange={this.handleSelectQualification}
        />,
        qualification.qwApprovalDesignationNo,
        qualification?.title
          ? qualification.title[this.props.inputLanguage] ||
            qualification.title["en"]
          : this.props.t("misc.none", { lng: this.props.inputLanguage }),
        ,
        qualification.type
          ? filters.qualificationType[this.props.inputLanguage].find(
              (type) => type.value === qualification.type
            ).label
          : this.props.t("misc.none", { lng: this.props.inputLanguage }),
        qualification.level
          ? filters.qualificationLevel[this.props.inputLanguage].find(
              (level) => level.value === qualification.level
            ).label
          : this.props.t("misc.none", { lng: this.props.inputLanguage }),
        qualification.awardingBody
          ? filters.awardingBody[this.props.inputLanguage].find(
              (awardingBody) =>
                awardingBody.value === qualification.awardingBody
            ).label
          : this.props.t("misc.none", { lng: this.props.inputLanguage }),
      ];
    });

    const manualQualifications = this.props.manualQualifications.map(
      (manualQualification) => {
        return [
          <CheckboxElement
            checked={this.state.selectedQualifications.has(
              manualQualification.uuid
            )}
            value={manualQualification.uuid}
            onChange={this.handleSelectQualification}
          />,
          this.props.t("misc.notApplicable", { lng: this.props.inputLanguage }),
          <Link
            to={"#"}
            target={"_blank"}
            data-id={manualQualification.uuid}
            onClick={(e) => {
              this.props.handleLoadManualQualification(e, manualQualification);
              this.props.handleSetStep(e, STEP_QUALIFICATION_CREATE);
            }}
          >
            {manualQualification.title[this.props.inputLanguage] ||
              manualQualification.title[
                this.props.inputLanguage === "en" ? "cy" : "en"
              ]}
          </Link>,
          manualQualification.type
            ? filters.qualificationType[this.props.inputLanguage].find(
                (type) => type.value === manualQualification.type
              ).label
            : this.props.t("misc.none", { lng: this.props.inputLanguage }),
          manualQualification.level.length === 0
            ? this.props.t("misc.none", { lng: this.props.inputLanguage })
            : manualQualification.level.length > 1
            ? this.props.t("misc.multiple", { lng: this.props.inputLanguage })
            : filters.qualificationLevel[this.props.inputLanguage].find(
                (level) => level.value === manualQualification.level[0]
              ).label,
          manualQualification.awardingBody
            ? filters.awardingBody[this.props.inputLanguage].find(
                (awardingBody) =>
                  awardingBody.value === manualQualification.awardingBody
              ).label
            : this.props.t("misc.none", { lng: this.props.inputLanguage }),
        ];
      }
    );

    return (
      <Form multi={true}>
        <FormHeader
          title={this.props.t(
            "local:view.courses.create.tabs.qualifications.step.view.title"
          )}
          introduction={this.props.t(
            "local:view.courses.create.tabs.qualifications.step.view.introduction"
          )}
        />
        <ErrorNavigation
          field={this.props.errorActiveField}
          handleClearActiveErrors={this.props.handleClearActiveErrors}
        />

        {this.props.unknownQualifications.size === 0 && (
          <Fragment>
            {/* Existing qualification */}
            <AutocompleteTextfieldApiElement
              key={this.props["qualificationLabel"]} // Force rerender to clear textfield after label changes.
              size={"large"}
              name={"qualification"}
              label={this.props.t(
                "local:view.courses.create.tabs.qualifications.step.view.field.existingQualification.label"
              )}
              placeholder={this.props.t(
                "local:view.courses.create.tabs.qualifications.step.view.field.existingQualification.placeholder"
              )}
              description={this.props.t(
                "local:view.courses.create.tabs.qualifications.step.view.field.existingQualification.description"
              )}
              advancedDescription={
                this.props.authentication.hasRole(ROLE_STAFF) && {
                  link: {
                    text: this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.field.existingQualification.advancedDescription.text"
                    ),
                  },
                  body: (
                    <Trans
                      i18nKey={
                        "local:view.courses.create.tabs.qualifications.step.view.field.existingQualification.advancedDescription.body"
                      }
                      components={[
                        <Link
                          to={"#"}
                          target={"_blank"}
                          onClick={(e) =>
                            this.props.handleSetStep(
                              e,
                              STEP_QUALIFICATION_CREATE
                            )
                          }
                        />,
                      ]}
                    />
                  ),
                }
              }
              suffix={
                <Button
                  classes={["button", "button--suffix", "button--style-blue"]}
                  onClick={this.handleAddQualification}
                  disabled={!this.props["qualificationId"]}
                >
                  {this.props.t(
                    "local:view.courses.create.tabs.qualifications.step.view.field.existingQualification.callToAction"
                  )}
                </Button>
              }
              hasButton={true}
              api={this.props.qualificationsApiGetEndpoint(
                "qualifications_api_qualifications_mq"
              )}
              authorize={true}
              queryParameter={"search"}
              keyField={"qwApprovalDesignationNo"}
              valueField={"title"}
              dataFields={["qwApprovalDesignationNo", "title"]}
              keyword={this.props["qualificationLabel"]}
              acceptLanguage={this.props.inputLanguage}
              value={this.props["qualificationId"]}
              errors={this.props.errors["qualificationId"]}
              onChange={this.props.handleChange}
            />

            {(this.props.qualifications.length > 0 ||
              this.props.manualQualifications.length > 0) && (
              <Fragment>
                <ResultsCounter
                  count={
                    this.props.qualifications.length +
                    this.props.manualQualifications.length
                  }
                >
                  <span>
                    {this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.table.entity"
                    )}
                  </span>
                  <Actions>
                    <ButtonSecondary
                      classes={["button--large"]}
                      onClick={this.handleRemoveQualifications}
                    >
                      {this.props.t(
                        "local:view.courses.create.tabs.qualifications.step.view.table.control.remove"
                      )}
                    </ButtonSecondary>
                  </Actions>
                </ResultsCounter>
                <Table
                  headers={[
                    this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.table.header.select"
                    ),
                    this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.table.header.referenceNumber"
                    ),
                    this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.table.header.title"
                    ),
                    this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.table.header.type"
                    ),
                    this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.table.header.level"
                    ),
                    this.props.t(
                      "local:view.courses.create.tabs.qualifications.step.view.table.header.awardingBody"
                    ),
                  ]}
                  rows={qualifications.concat(manualQualifications)}
                />
              </Fragment>
            )}
          </Fragment>
        )}

        {/* Unknown qualifications*/}
        <CheckboxElement
          id={"unknownQualifications"}
          name={"unknownQualifications"}
          // label={this.props.t('local:view.courses.create.tabs.qualifications.step.view.field.unknownQualifications.label')}
          label={
            this.props.courses.assets.courses.qualificationUnknown[
              i18n.language
            ]
          }
          checked={this.props.unknownQualifications.has("1")}
          value={"1"}
          onChange={this.handleToggleUnkownQualifications}
          basic={true}
        />

        {/* <FormFooter>
          <FormSubmit url={'#'}>
            {this.props.t('local:view.courses.create.tabs.qualifications.step.view.callToAction')}
          </FormSubmit>
        </FormFooter> */}
      </Form>
    );
  }
}

export default withQualificationsApi(process.env)(
  withAssets(
    withAuthentication(withTranslation("local")(QualificationsViewStep))
  )
);
